var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.handleScreenFull}},[_c('icon',{class:("" + _vm.iconClass),attrs:{"name":"fullscreen","scale":_vm.scale}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }